import defaultState from './state';

export default {
    /**
     * Sets user data
     *
     * @param    {object}   state   Vuex state.
     * @param   {object}  userData   User data.
     *
     */
    setUser(state, userData) {
        if (userData.meta_data) {
            if (Array.isArray(userData.meta_data)) {
                userData.meta_data = {};
            }
        }

        if (! userData?.meta_data?.avatar) {
            userData.meta_data.avatar = '';
        }

        state.user = { ...state.user, ...userData };
    },

    /**
     * Sets register flag
     *
     * @param   {object}  state  Vuex state.
     * @param   {boolean}  payload  Register processing state.
     */
    registerProcessing(state, payload) {
        state.registeringUser = payload;
    },

    /**
     * Sets register flag
     *
     * @param   {object}  state  Vuex state.
     * @param   {string}  payload  New Avatar url.
     */
    newAvatar(state, payload) {
        state.user.meta_data.avatar = payload;
    },

    /**
     * Sets user licenses
     *
     * @param   {object}   state     Vuex state.
     * @param   {boolean}  licenses  Licenses data
     */
    setLicenses(state, licenses) {
        state.licenses = licenses;
    },

    /**
     * Sets invoices
     *
     * @param   {object}   state     Vuex state.
     * @param   {Array}  invoices  Invoices list.
     */
    setInvoices(state, invoices) {
        state.invoices = invoices;
    },

    /**
     * Sets user meta
     *
     * @param   {object}   state Vuex state.
     * @param   {object}   meta  User meta.
     *
     */
    replaceUserMeta(state, meta) {
        state.user = {
            ...state.user,
            meta_data: {
                ...meta,
            },
        };
    },

    /**
     * Set products.
     *
     * @param   {object}  state    Vuex state.
     * @param   {Array} products Products.
     */
    setProducts(state, products) {
        state.products = products;
    },

    /**
     * Sets user card
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   card  User card.
     *
     */
    setUserCard(state, card) {
        state.userCard = card ? { ...card } : card;
    },

    /**
     * Sets payment methods.
     *
     * @param   {object}  state    Vuex state.
     * @param   {Array}   methods  Payment methods.
     *
     */
    setPaymentMethods(state, methods) {
        state.paymentMethods = methods ? [...methods] : methods;
    },

    /**
     * Sets user plan
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   plan  User plan.
     *
     */
    replaceUserPlan(state, plan) {
        state.userPlans[0] = plan;
    },

    /**
     * Changes UI state
     *
     * @param   {object}  state    Vuex state.
     * @param   {object}  newState New UI state.
     *
     */
    changeUIState(state, newState) {
        state.UIState = {
            ...state.UIState,
            ...newState,
        };
    },

    /**
     * Sets licenses
     *
     * @param   {object}   state Vuex state.
     * @param   {object}   licenses  User licenses.
     *
     */
    updateLicenses(state, licenses) {
        state.licenses = licenses;
    },

    /**
     * Sets user subscriptions
     * This is a Stripe subscription object.
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   subscription  User plan.
     */
    setUserSubscription(state, subscription) {
        state.userSubscription = subscription;
    },

    /**
     * Sets currently selected subscriptions
     * This is a laravel Subscription model.
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   subscription  User plan.
     */
    setCurrentSubscription(state, subscription) {
        state.currentSubscription = subscription;
    },

    /**
     * Sets upcoming invoice
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   invoice  User plan.
     */
    setUpcomingInvoice(state, invoice) {
        state.upcomingInvoice = invoice;
    },

    /**
     * Sets presumed invoice
     *
     * @param   {object}   state Vuex state.
     * @param   {Array}   invoice  User plan.
     */
    setPresumedInvoice(state, invoice) {
        state.presumedInvoice = invoice;
    },

    /**
     * Save presumed invoice as upcomming.
     *
     * @param   {object}   state Vuex state.
     */
    savePresumedInvoice(state) {
        state.upcomingInvoice = { ...state.presumedInvoice };
    },

    /**
     * Set login redirect url.
     *
     * @param {object} state  Vuex state.
     * @param {string} url    Redirect URL.
     */
    setLoginRedirectUrl(state, url) {
        state.loginRedirectUrl = url;
    },

    /**
     * Resets state
     *
     * @param {object} state  Vuex state.
     */
    resetState(state) {
        Object.assign(state, defaultState());
    },

    /**
     * Set profile controls
     *
     * @param {object} state    Vuex state.
     * @param {*}      controls Profile controls array or false on error.
     */
    setProfileControls(state, controls) {
        state.profileControls = controls;
    },
};
